import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOverflow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 4,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 4a2 2 0 100-4 2 2 0 000 4zm8 0a2 2 0 100-4 2 2 0 000 4zm10-2a2 2 0 11-4 0 2 2 0 014 0z",
		fill: "#333"
	})
});
export default SvgOverflow;
